
const initialState = {
  selected_firm: null,
  firms: [],
};

const firmsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SELECTED_FIRM':
      return {
        ...state,
        selected_firm: action.payload,
      };
    case 'RESET_SELECTED_FIRM':
      return {
        ...state,
        selected_firm: null,
      };
    case 'SET_FIRMS':
      return {
        ...state,
        firms: action.payload,
      };
    default:
      return state;
  }
};

export default firmsReducer;
